import React, { useState } from 'react';
import ConfigTicketUserTypeList from './config_ticket_user_type_list';
import globalHelper from '../../../../helpers/functions/global.helper';
import PageHeaderComponent from '../../../../helpers/components/page_header.component';
import { Button, Form, Input, Modal, Space, notification } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import AddTicketUserTypeModal from './add_ticket_user_type_modal';
import ticketUserTypeService from '../../../../services/config/ticket_user_type.service';
import EditTicketUserTypeModal from './edit_ticket_user_type_modal';

const TicketUserTypeLayout = () => {
    const [save_form] = Form.useForm();
    const [update_form] = Form.useForm();
    const [state, setState] = useState({
        create_modal : false,
        edit_modal : null,

        save_loading : false,
        update_loading : false,

        modal : 0,
        refresh : 0,
    })

    const [timer, setTimer] = useState();

    const [filter, setFilter] = useState({
        search : null,
    });

    const doneTyping = async (input) => {
        clearTimeout(timer);
        const newTimer = setTimeout(() => {
            setFilter(filter => ({ ...filter, search: input, }));
            // changeFilter('search', input);
        }, 300);
        setTimer(newTimer);
    }

    const openEditModal = (ticket_user_type_id) => {
        setState(state => ({...state, edit_modal : ticket_user_type_id, }));
    }

    const saveTicketUserType = async () => {
        setState(state => ({...state, save_loading : true, }));
        
        const { name, descriptions, min_age, max_age, color, is_config_face, } = save_form?.getFieldsValue();
        const saveTicketUserTypeResponse = await ticketUserTypeService?.saveTicketUserType({
            name, descriptions, min_age, max_age, is_config_face,
            color : color?.toHex(),
        })?.catch(err => setState(state => ({...state, save_loading : false,})));

        notification.success({
            message : 'New ticket group added',
        })

        setState(state => ({...state, save_loading : false, refresh : (state?.refresh + 1), create_modal : null,}));
    }

    const updateTicketUserType = async () => {
        setState(state => ({...state, update_loading : true, }));

        const ticket_user_type_id = state?.edit_modal;
        const { name, descriptions, min_age, max_age, is_config_face, color, } = update_form?.getFieldsValue();

        const colorHex = (isHex(color) ? color : color?.toHex())

        const updateTicketTypeResponse = await ticketUserTypeService?.updateTicketUserType(ticket_user_type_id, {
            name, descriptions, min_age, max_age, is_config_face, color : colorHex,
        }).catch(err => setState(state => ({...state, update_loading : false, })));

        notification?.success({
            message : 'Ticket user type updated',
        })

        setState(state => ({...state, update_loading : false, refresh : (state?.refresh + 1), edit_modal : null, }));
    }

    const isHex = (value) => {
        // Check if the value is a string and matches the hex pattern
        return typeof value === 'string' && /^#?[0-9a-fA-F]+$/.test(value);
    }

    const deleteTicketUserType = async (ticket_user_type_id) => {
        const deleteTicketUserTypeResponse = await ticketUserTypeService?.deleteTicketUserType(ticket_user_type_id);
        notification?.success({
            message : 'Ticket user type Deleted',
        })

        setState(state => ({...state, refresh : (state?.refresh + 1)}));
    }

    return (
        <>
            <div className='mobile-padding-12'>
                <div style={{marginBottom: 24, textAlign:'start'}}>
                    <PageHeaderComponent title={'Ticket Groups'} />
                </div>
                <div className='filter-panel'>
                    <div>
                        <Input
                        onChange={(e) => doneTyping(e.target.value)}
                        name="search"
                        prefix={<SearchOutlined style={{color :'var(--secondary-text-color)'}} />}
                        placeholder='Search Ticket Groups'
                        style={{minWidth: '100%',}}
                        allowClear
                        />
                    </div>

                    <div style={{display:'flex', alignItems:'center', marginTop:12, gap:8,}}>
                        <div>
                            <div className='filter-panel' style={{textAlign:'start'}}>
                                <Space direction={globalHelper?.isMobileScreen() ? 'vertical' : 'horizontal'}>
                                </Space>
                            </div>
                        </div>

                        <div style={{marginLeft:'auto'}}>
                            <Button
                            type='primary'
                            onClick={() => setState(state => ({...state, create_modal : true,}))}
                            >
                                New Ticket Groups
                            </Button>
                        </div>
                    </div>
                </div>

                <div style={{ marginTop : 24, }}>
                    <ConfigTicketUserTypeList filter={filter} refresh={state?.refresh} openEditModal={openEditModal} deleteTicketUserType={deleteTicketUserType} />
                </div>
            </div>

            <Modal
            title="New Ticket Groups"
            open={state?.create_modal}
            onCancel={() => {
                setState(state => ({...state, create_modal : false, modal : (state?.modal + 1)}));
                // save_form?.resetFields();
            }}
            onOk={() => save_form.submit()}
            width={800}
            // style={{ top : 20, }}
            confirmLoading={state?.save_loading}
            >
                <Form
                form={save_form}
                onFinish={saveTicketUserType}
                layout='vertical'
                >
                    <AddTicketUserTypeModal form={save_form}/>
                </Form>
            </Modal>

            <Modal
            title="Edit Ticket Group"
            open={state?.edit_modal}
            onCancel={() => {
                setState(state => ({...state, edit_modal : null, modal : (state?.modal + 1)}));
                // save_form?.resetFields();
            }}
            onOk={() => update_form.submit()}
            width={800}
            // style={{ top : 20, }}
            confirmLoading={state?.update_loading}
            >
                <Form
                form={update_form}
                onFinish={updateTicketUserType}
                layout='vertical'
                >
                    <EditTicketUserTypeModal form={update_form} ticket_user_type_id={state?.edit_modal} modal={state?.modal} />
                </Form>
            </Modal>
        </>
    );
}

export default TicketUserTypeLayout;